import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

const performCustomAction = (params) => {
  const requestOptions = {
    method: params.method,
    url: `${urls.domain}${params.action}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const sendToNotarize = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.notarize,
    data,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

const confirmSendToNotarize1583 = () => {
  const requestOptions = {
    method: 'POST',
    url: urls.notarize_form1583,
  };

  return axios(requestOptions)
    .then(res => res.data);
};


const CancelNotarize1583 = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.notarize}/${data.notary_package_id}/cancel`
  };

  return axios(requestOptions)
    .then(res => res.data);
};

const getItemNotarize = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.notarize}${id}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

const CancelItemNotarize = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.notarize}/${data.notary_package_id}/cancel`
  };

  return axios(requestOptions)
    .then(res => res.data);
};

const getAllNotarizePackages = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.notarize,
    params,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

const getForwardingAddresses = (params) => {
  if (!params)
    params = {
      page: 1,
      limit: 10
    };

  const requestOptions = {
    method: 'GET',
    url: urls.fwd_addresses,
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const performSmsServiceAction = (params) => {
  /* Legend for methods:
    GET: get sms service params
    POST: activate sms service
    PUT: update sms service params
    DELETE: deactivate sms service
  */

  let requestOptions = {
    method: params.method,
    url: urls.sms_service
  };

  if (params.data)
    requestOptions.data = params.data;

  return axios(requestOptions)
    .then(res => res.data);
}

const getUserStats = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.user_stats
  };

  return axios(requestOptions)
    .then(res => res.data);
}



const GetCurrentStats = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.current_stats
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const getJointAccounts = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.joint_accounts
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const addJointAccount = (params) => {
  let requestOptions = {
    method: 'POST',
    url: urls.joint_accounts,
    params: {
      joint_account: params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const updateJointAccount = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.joint_accounts}/${data.id}`,
    params: {
      joint_account: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const removeJointAccount = (id) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.joint_accounts}/${id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const getUserPhones = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.phone_numbers
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const GetPhoneNumber = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.phone_numbers}/${id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const getUserPhoneUsages = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.phone_usages,
    // params: {
    //   page: 1,
    //   limit: 100
    // }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const searchPhoneNumbers = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.phone_numbers}/search`,
    params: {
      search: data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const buyPhoneNumber = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.phone_numbers,
    data: {
      phone_number: data
    },
    //paramsSerializer: data => qs.stringify(data, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const updatePhoneNumber = (params, id) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.phone_numbers}/${id}`,
    params: {
      phone_number: params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const deletePhoneNumber = (id) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.phone_numbers}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const getOutgoingCallFroms = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.phone_numbers}/${id}/outgoing_calls`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const addOutgoingCallNumber = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.phone_numbers}/${data.id}/outgoing_calls`,
    params: data.params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const updateOutgoingCallNumber = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.phone_numbers}/${data.id}/outgoing_calls/${data.params.id}`,
    params: {
      caller_phone_number: data.params.caller_phone_number
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const deleteOutgoingCallNumber = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.phone_numbers}/${data.id}/outgoing_calls/${data.outgoing_id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const getPhoneExtensions = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.phone_numbers}/${id}/phone_extensions`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const createPhoneExtension = (data) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.phone_numbers}/${data.id}/phone_extensions`,
    data: data.ext
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const updatePhoneExtension = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.phone_numbers}/${data.id}/phone_extensions/${data.ext_id}`,
    params: data.ext,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const removePhoneExtension = (data) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.phone_numbers}/${data.id}/phone_extensions/${data.ext_id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const validateNewAccount = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.validate_account,
    params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const ValidateClient = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.validate_client,
    params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const addForwardingAddress = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.fwd_address,
    params: {
      forward_address: data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const editForwardingAddress = (data, id) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.fwd_address}/${id}`,
    params: {
      forward_address: data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const removeForwardingAddress = (id) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.fwd_address}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const getLiveReceptionistList = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.receptionist
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const subscribeToLiveReceptionist = (id) => {
  let requestOptions = {
    method: 'POST',
    url: urls.receptionist_service,
    params: {
      plan_id: id
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const unsubscribeFromLiveReceptionist = () => {
  let requestOptions = {
    method: 'DELETE',
    url: urls.receptionist_service
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const getPhonePorting = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.phone_porting
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const sendPhonePorting = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.phone_porting,
    data: data
  }

  return axios(requestOptions)
    .then(res => res.data);
}




const updateAutomaticMailAction = (data , id ,  action , role) => {
  const admin_url = `${urls.admin.customers}/${id}/subscribe_automatic_mail_action_requests/${action}`
  const customer_url = `${urls.account}/subscribe_automatic_mail_action_requests/${action}`
  let requestOptions = {
    method: 'PUT',
    url: role=="admin" ?  admin_url : customer_url,
    data: data
    };

  return axios(requestOptions)
    .then(res => res.data);
}

const GetCharges = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.charges,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const GetUserPlan = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.user_plan
  }
  return axios(requestOptions)
    .then(res => res.data);
}

const GetTransferClients = () => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.account_transfers}/clients`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const GetClientPlans = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.admin.account_transfers}/period_plans?client_id=${id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const TransferAccount = (params) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.account_transfers,
    data: params,

  }

  return axios(requestOptions)
    .then(res => res.data);
}

const UpgradePlan = (params) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.subscriptions}/upgrade`,
    params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

const UploadAccountDocument = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.account_documents,
    data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const GetBalanceAdjustments = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.balance_adjustments,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

const UpdatePhotoIdExpiration = (data) => {
  let requestOptions = {
    method: 'PUT',
    url: urls.account + '/update_photo_id_expires_on',
    data: { customer: data }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export {
  sendToNotarize,
  confirmSendToNotarize1583,
  CancelNotarize1583,
  getItemNotarize,
  CancelItemNotarize,
  getAllNotarizePackages,
  performCustomAction,
  getForwardingAddresses,
  performSmsServiceAction,
  getUserStats,
  getJointAccounts,
  addJointAccount,
  updateJointAccount,
  removeJointAccount,
  getUserPhones,
  GetPhoneNumber,
  getUserPhoneUsages,
  searchPhoneNumbers,
  buyPhoneNumber,
  updatePhoneNumber,
  deletePhoneNumber,
  getOutgoingCallFroms,
  addOutgoingCallNumber,
  updateOutgoingCallNumber,
  deleteOutgoingCallNumber,
  validateNewAccount,
  ValidateClient,
  addForwardingAddress,
  editForwardingAddress,
  removeForwardingAddress,
  getLiveReceptionistList,
  subscribeToLiveReceptionist,
  unsubscribeFromLiveReceptionist,
  getPhonePorting,
  sendPhonePorting,
  getPhoneExtensions,
  createPhoneExtension,
  updatePhoneExtension,
  removePhoneExtension,
  updateAutomaticMailAction,
  GetCharges,
  GetUserPlan,
  GetCurrentStats,
  GetTransferClients,
  GetClientPlans,
  TransferAccount,
  UpgradePlan,
  UploadAccountDocument,
  GetBalanceAdjustments,
  UpdatePhotoIdExpiration
};
